import React from 'react';
import {Link} from 'react-router-dom';
import Logo from '../Signin/Logo_svg.svg';
import BackIcon from './Back.svg';

import './Register.scss';
import theme from '../../shared/Theme/Theme';
import {makeStyles} from '@material-ui/core/styles';

import Checkbox from '@material-ui/core/Checkbox';
// export default class Register extends Component {

const userStyles = makeStyles(theme => ({
    checkboxContainer: {
        "&:hover": {
            backgroundColor:'transparent',
        },
        "&:active": {
            backgroundColor:'transparent',
        }
    }
}))

export default function Register() {

    const classes = userStyles();

    const [state, setState] = React.useState({
        checkedA: true,
      });
    
    const handleChange = (event) => {
        setState({...state, [event.target.name]: event.target.checked});
    };
    // render() {
        return (
            <div className="login-container-bg">
                <div className="overlay"></div>
                <div className="login-form">
                    <div className="logo-container">
                        <Link to='/'><img src={Logo} alt="Logo"/></Link>
                        <p className="logo-title">GameMeet</p>
                    </div>
                    <div className="register-form-container">
                        <div className="creat-form-container">
                            <Link to="./signin"><img src={BackIcon}/></Link>
                            <p className="creat-form-title">
                                Create an Account
                            </p>
                        </div>
                        <div className="create-information-button">
                            <p>User Name</p>
                            <input className="signin-button"></input>
                            <p className="error-message">The username cannot allow to use alpha-numeric characters as well as dashes and underscores. </p>
                        </div>
                        <div className="create-information-button">
                            <p>Email</p>
                            <input className="signin-button"></input>
                            <p className="error-message">The username field is empty</p>
                        </div>
                        <div className="create-information-button">
                            <p>Password</p>
                            <input className="signin-button"></input>
                            <p className="error-message">The password field is empty</p>
                        </div>
                        <div className="create-information-button">
                            <p>Confirm Password</p>
                            <input className="signin-button"></input>
                        </div>
                        <div className="LogIn">
                           <button className="login-button">Log in</button>
                        </div>
                        <div className="termandservice">
                            <Checkbox
                                className={classes.checkboxContainer}
                                disableRipple
                                disableFocusRipple
                                checked={state.checkedB}
                                onChange={handleChange}
                                name="checkedA"
                                color="primary"
                            /> 
                            <p>Agree with</p>
                            <p className="termagree-hyperlink">
                                <a target="_blank" rel="noopener noreferrer" href="https://youtube.com/">
                                Terms of Service</a>
                            </p>
                            <p>and</p>
                            <p className="termagree-hyperlink">
                            <a target="_blank" rel="noopener noreferrer" href="https://youtube.com/">
                            Privacy Policy</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    //}
}
